import './index.scss';

async function initComponent(element) {
    const url = element.data('url')
    const frameUrl = `https://w.soundcloud.com/player/?url=${url}&auto_play=false&show_artwork=true`
    
    const frame = element.find('iframe')
    frame.attr('src', frameUrl)
}

window.addEventListener('onGdprConsent', (event) => {
    if (event.detail.name !== 'SOUNDCLOUD') {
        return
    }

    $(function () {
        const elements = $('.soundcloud-component')

        for (const element of elements) {
            initComponent($(element))
        }
    })
})